<template>
  <div style="padding: 0 10px">
    <div style="text-align: left">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="货代公司">
          <el-input maxlength='450' placeholder="请输入运输方式" v-model="formInline.forwarder"></el-input>
        </el-form-item>
        <el-form-item label="运输方式">
          <el-input maxlength='450' placeholder="请输入运输方式" v-model="formInline.shippingType"></el-input>
        </el-form-item>
        <el-form-item label="物流公司">
          <el-select placeholder="全部" v-model="formInline.logisticsCompanyCode">
            <el-option label="OCS" value="OCS"> </el-option>
            <el-option label="杭州义达" value="YD"> </el-option>
            <el-option label="杭州思凯比" value="SKB"> </el-option>
            <el-option label="广州天汇" value="TH"> </el-option>
            <el-option label="圆通国际" value="YTGJ"> </el-option>
            <el-option label="通达" value="TD"> </el-option>
            <el-option label="千速" value="QS"> </el-option>
            <el-option label="华源达" value="HYD"> </el-option>
            <el-option label="万邦" value="WB"> </el-option>
            <el-option label="UBI利通" value="UBI"> </el-option>
            <el-option label="联邦快递" value="Fedex"> </el-option>
            <el-option label="迅田" value="XT"> </el-option>
            <el-option label="其他" value="other"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种">
          <el-select placeholder="全部" v-model="formInline.currencyType">
          <el-option label="日元" value="jpy"></el-option>
          <el-option label="美元" value="usd"></el-option>
          <el-option label="人民币" value="cny"></el-option>
          <el-option label="韩元" value="krw"></el-option>
          <el-option label="英镑" value="gbp"></el-option>
          <el-option label="欧元" value="eur"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面单尺寸">
          <el-select placeholder="全部" v-model="formInline.printPaperSize">
          <el-option v-for="item in sheetSizeList" :key="item.id" :label="`${item.width}*${item.height}`"
            :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 30px" type="primary" @click="search">搜索
          </el-button>
          <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: left;margin-bottom: 10px">
      <el-button @click="batchEdit" type="primary" :disabled="!selArray.length">批量编辑</el-button>
    </div>
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query"
      :hasHeader="false" :isRowSelection="true" @selectChange="selChange" rowKey="intForwarderConfigId">
      <template slot="logisticsCompanyCode" slot-scope="{ text, record, index }">
        <el-select v-model="record.logisticsCompanyCode" placeholder="请选择"
          @change="logisticsChange($event, record, index)" :detail="record" :disabled="!record.canChanged">
          <el-option label="OCS" value="OCS"> </el-option>
          <el-option label="杭州义达" value="YD"> </el-option>
          <el-option label="杭州思凯比" value="SKB"> </el-option>
          <el-option label="广州天汇" value="TH"> </el-option>
          <el-option label="圆通国际" value="YTGJ"> </el-option>
          <el-option label="通达" value="TD"> </el-option>
          <el-option label="千速" value="QS"> </el-option>
          <el-option label="华源达" value="HYD"> </el-option>
          <el-option label="万邦" value="WB"> </el-option>
            <el-option label="UBI利通" value="UBI"> </el-option>
            <el-option label="联邦快递" value="Fedex"> </el-option>
            <el-option label="迅田" value="XT"> </el-option>
          <el-option label="其他" value="other"> </el-option>
        </el-select>
      </template>
      <template slot="channelNo" slot-scope="{ text, record, index }">
        <el-select v-model="record.channelDesc" placeholder="请选择"
          :disabled="!record.canChanged || record.logisticsCompanyCode == 'other'"
          @change="carrierWayChange($event, record, index)"
          @visible-change="channelOnFoucs($event, record.logisticsCompanyCode, index)" filterable>
          <el-option v-for="item in carrierWayList" :key="item.logisticsChannelId" :label="item.channelName"
            :value="item.channelNo">
          </el-option>
        </el-select>
      </template>
      <template slot="currencyType" slot-scope="{ text, record, index }">
        <el-select v-model="record.currencyType" placeholder="请选择" :disabled="!record.canChanged">
          <el-option label="日元" value="jpy"></el-option>
          <el-option label="美元" value="usd"></el-option>
          <el-option label="人民币" value="cny"></el-option>
          <el-option label="韩元" value="krw"></el-option>
          <el-option label="英镑" value="gbp"></el-option>
          <el-option label="欧元" value="eur"></el-option>
        </el-select>
      </template>
      <template slot="size" slot-scope="{ text, record, index }">
        <el-select v-model="record.size" placeholder="请选择" :disabled="!record.canChanged">
          <el-option v-for="item in sheetSizeList" :key="item.id" :label="`${item.width}*${item.height}`"
            :value="item.id">
          </el-option>
        </el-select>
      </template>
      <div slot="action" slot-scope="{ text, record,index }">
        <a href="javascript:;" style="padding: 0 10px" @click="changeStatus(record, index)"
          v-if="!record.canChanged">编辑</a>
        <a href="javascript:;" style="padding: 0 10px" @click="edit(record, index)" v-if="record.canChanged">保存</a>
      </div>
    </WmsTable>
    <el-dialog :visible="batchEditVisible" title="批量编辑" destroy-on-close @close="batchEditVisible = false">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="物流公司（API）:" prop="logisticsCompanyCode">
          <el-select v-model="form.logisticsCompanyCode" placeholder="请选择" style="float: left">
            <el-option label="OCS" value="OCS"> </el-option>
            <el-option label="杭州义达" value="YD"> </el-option>
            <el-option label="杭州思凯比" value="SKB"> </el-option>
            <el-option label="广州天汇" value="TH"> </el-option>
            <el-option label="圆通国际" value="YTGJ"> </el-option>
            <el-option label="通达" value="TD"> </el-option>
            <el-option label="千速" value="QS"> </el-option>
            <el-option label="华源达" value="HYD"> </el-option>
            <el-option label="万邦" value="WB"> </el-option>
            <el-option label="UBI利通" value="UBI"> </el-option>
            <el-option label="其他" value="other"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式（API）:" prop="channelNo">
          <el-select v-model="form.channelNo" placeholder="请选择" :disabled="form.logisticsCompanyCode == 'other'"
            @visible-change="channelOnFoucs($event, form.logisticsCompanyCode)" style="float: left" filterable>
            <el-option v-for="item in carrierWayList" :key="item.logisticsChannelId" :label="item.channelName"
              :value="item.channelNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种:" prop="currencyType">
          <el-select v-model="form.currencyType" placeholder="请选择" style="float: left">
            <el-option label="日元" value="jpy"></el-option>
            <el-option label="美元" value="usd"></el-option>
            <el-option label="人民币" value="cny"></el-option>
            <el-option label="韩元" value="krw"></el-option>
            <el-option label="英镑" value="gbp"></el-option>
            <el-option label="欧元" value="eur"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面单尺寸:" prop="size">
          <el-select v-model="form.size" placeholder="请选择" style="float: left">
            <el-option v-for="item in sheetSizeList" :key="item.id" :label="`${item.width}*${item.height}`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="ok">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { getLogistics, saveLogistics, getChannel, logisticsApiConfigBatchEdit } from '@/apis/configure'
import { columns, sheetSizeList } from './indexData.js'
import { Loading } from "element-ui";
export default {
  title: "物流API关联配置",
  name: "logisticsConfig",
  components: { WmsTable },
  data() {
    return {
      formInline: {
        regionCode: undefined,
        shippingType: undefined
      },
      query: {
        total: 0,
        current: 1,
        pageSize: 10
      },
      dataSource: [],
      columns,
      sheetSizeList,
      carrierWayList: [],
      batchEditVisible: false,
      form: {},
      selArray: [],
      rules: {
        logisticsCompanyCode: [{ required: true, message: '请选择物流公司', trigger: 'blur' }],
        channelNo: [{ required: true, message: '请选择物流方式', trigger: 'blur' }],
        currencyType: [{ required: true, message: '请选择币种', trigger: 'blur' }],
        size: [{ required: true, message: '请选择面单尺寸', trigger: 'blur' }],
      },
      loading: {
        num: 0,
        data: null,
        open: function () {
          this.num += 1;
          if (!this.data) {
            this.data = Loading.service({
              lock: true,
              text: "Loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
          }
        },
        close: function () {
          this.num -= 1;
          if (this.num <= 0) {
            this.data.close();
            this.data = null;
          }
        },
      }
    };
  },
  mounted() {
    this.getLogisticsList()
  },
  methods: {
    //获取物流API分页
    getLogisticsList() {
      let params = {
        ...this.formInline,
        pageSize: this.query.pageSize,
        pageNum: this.query.current
      }
      if(params.printPaperSize){
        let size = this.sheetSizeList.filter(item => item.id == params.printPaperSize)[0]
        params.printPaperSizeHigh = size.height
        params.printPaperSizeWide= size.width
      }
      getLogistics(params).then(({ code, data }) => {
        if (code === 0) {
          let records = data.records
          records.forEach(item => {
            //编辑默认关闭状态
            item.canChanged = false
            //为数据添加原货代公司/运输方式值 用于对比值的改变 触发事件
            item.oldlogisticsCompanyCode = item.logisticsCompanyCode
            item.oldchannelNo = item.channelNo
            //运输方式下拉选择框数据初始化
            item.logisticsChannelDTOList = item.logisticsChannelDTOList ? item.logisticsChannelDTOList : []
            //为数据添加运输方式前台展示的值
            item.channelDesc = item.logisticsChannelDTOList.filter(item_Desc => {
              return item_Desc.channelNo == item.channelNo
            })[0]
            if (item.channelDesc) {
              item.channelDesc = item.channelDesc.channelName
            }
            item.size = item.printPaperSizeWide && item.printPaperSizeHigh ? `${item.printPaperSizeWide}${item.printPaperSizeHigh}` : ''
          })
          this.dataSource = records
          //表格总数赋值
          this.query.total = data.total
        }
      })
    },
    //搜索
    search() {
      this.query = {
        total: 0,
        current: 1,
        pageSize: 10
      }
      this.getLogisticsList()
    },
    //重置搜索
    rest() {
      this.formInline = {
        regionCode: undefined,
        shippingType: undefined
      }
      this.query = {
        total: 0,
        current: 1,
        pageSize: 10
      }
      this.getLogisticsList()
    },
    //表格change回调
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getLogisticsList();
    },
    //货代公司选择事件
    logisticsChange(event, record, index) {
      //新旧值相同,无事发生
      if (event == record.oldlogisticsCompanyCode) {
        return
      }
      //新旧值不相同,进入逻辑
      let data = [...this.dataSource]
      //清空运输方式和运输方式下拉选择框数据
      data[index].channelNo = null
      data[index].logisticsChannelDTOList = []
      data[index].channelDesc = ''
      this.dataSource = data
    },
    //运输方式改变回调
    carrierWayChange(event, record, index) {
      this.loading.open();
      let dataSource = [...this.dataSource]
      let data = { ...record }
      //监听change回调 为channelNo赋值
      data.channelNo = event
      //监听change回调 为前台显示的name赋值
      data.channelDesc = this.carrierWayList.filter(item => {
        return item.channelNo == event
      })[0].channelName
      dataSource[index] = data
      this.loading.close();
      this.$nextTick((_) => {
        this.dataSource = dataSource
      })

      return
      this.edit(data)
    },
    //运输方式获取焦点回调
    channelOnFoucs(event, logisticsCompanyCode) {
      //物流方式下拉框初始化
      this.carrierWayList = []
      //无值 判断是失去焦点事件,无事发生
      if (!event) {
        return;
      }
      //判断有没有选择货代公司
      if (!logisticsCompanyCode) {
        this.$message.warning('请先选择货代公司')
        return
      }
      //请求运输方式列表 为carrierWayList赋值
      getChannel({ logisticsCompanyCode: logisticsCompanyCode }).then(
        ({ code, data }) => {
          if (code == 0) {
            this.carrierWayList = data
          }
        }
      );
    },
    //切换编辑状态
    changeStatus(reocrd, index) {
      let data = [...this.dataSource]
      data[index].canChanged = true
      this.dataSource = data
    },
    //编辑
    edit(record, index) {
      if (!record.logisticsCompanyCode) {
        this.$message.warning('请选择货代公司')
        return false
      }
      if (record.logisticsCompanyCode != 'other' && !record.channelNo) {
        this.$message.warning('请选择物流方式')
        return false
      }
      if (!record.size) {
        this.$message.warning('请选择面单尺寸')
        return false
      }
      if (!record.currencyType) {
        this.$message.warning('请选择币种')
        return false
      }
      let size = this.sheetSizeList.filter(item => item.id == record.size)[0]
      let params = {
        channelNo: record.channelNo,
        logisticsCompanyCode: record.logisticsCompanyCode,
        intForwarderConfigIds: [record.intForwarderConfigId],
        printPaperSizeHigh: size.height,
        printPaperSizeWide: size.width,
        currencyType: record.currencyType
      }
      saveLogistics(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success('配置成功')
          // let data = [...this.dataSource]
          // data[index].canChanged = false
          // this.dataSource = data
          this.getLogisticsList()
        }
      })
    },
    selChange(sel) {
      this.selArray = sel;
    },
    batchEdit: function () {
      this.form = {}
      this.batchEditVisible = true
    },
    ok: function () {
      this.$refs.form.validate((v) => {
        if (v) {
          const params = {
            ...this.form,
            intForwarderConfigIds: this.selArray.map(v => v.intForwarderConfigId)
          }
          logisticsApiConfigBatchEdit(params).then(res => {
            if (res.code == 0) {
              this.batchEditVisible = false;
              this.$message.success('批量更新物流状态需要一定的时间，可稍后刷新查看')
              this.search()
            }
          })
        }
      })
    },
  },
};
</script>

<style scoped></style>
